import { useCallback, useState } from 'react';

import { Context } from './context';

export type ProvideProps<BannerComponentProps> = {
  Component: React.ComponentType<BannerComponentProps>;
  defaultProps: BannerComponentProps;
  children: React.ReactNode;
};

export const BannerProvider = <BannerComponentProps,>({
  Component,
  defaultProps,
  children,
}: ProvideProps<BannerComponentProps>): React.JSX.Element => {
  const [props, setProps] = useState<BannerComponentProps>({
    ...defaultProps,
  });
  const [show, setShow] = useState(false);

  const hideBanner = useCallback(() => setShow(false), []);
  const showBanner = useCallback(
    (passedProps: Record<string, unknown>) => {
      setProps({ ...props, ...passedProps });
      setShow(true);
    },
    [props]
  );

  return (
    <Context.Provider value={{ showBanner, hideBanner }}>
      {children}
      <Component
        data-qa="banner"
        data-testid="banner"
        handleOnClose={hideBanner}
        show={show}
        {...props}
      />
    </Context.Provider>
  );
};
